import Vue from 'vue'
import Router from 'vue-router'
import firebase from './firebase';

Vue.use(Router);

// función para cargar componentes de manera lazy,
// esto evita que la aplicación cargue componentes que no se usan
function loadView (view) {
  return () => import(`@/views/${view}.vue`)
}

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/Login'
    },
    {
      path: '/Home',
      name: 'Home',
      meta: {
        authentication: true,
      },
      component: loadView('Home')
    },
    {
      path: '/Configuration',
      name: 'Configuration',
      meta: {
        authentication: true,
      },
      component: loadView('Configuration')
    },
    {
      path: '/CowForm',
      name: 'CowForm',
      meta: {
        authentication: true,
      },
      component: loadView('CowForm')
    },
    {
      path: '/CowProfile/:type/:id',
      name: 'CowProfile',
      meta: {
        authentication: true,
      },
      props: true,
      component: loadView('CowProfile')
    },
    {
      path: '/DashAlert',
      name: 'DashAlert',
      meta: {
        authentication: true,
      },
      component: loadView('DashAlert')
    },
    {
      path: '/DashCow',
      name: 'DashCow',
      meta: {
        authentication: true,
      },
      component: loadView('DashCow')
    },
    {
      path: '/NewDashCow',
      name: 'NewDashCow',
      meta: {
        authentication: true,
      },
      component: loadView('NewDashCow')
    },
    {
      path: '/Table',
      name: 'Table',
      meta: {
        authentication: true,
      },
      component: loadView('SmartTable')
    },
    {
      path: '/DashResume',
      name: 'DashResume',
      meta: {
        authentication: true,
      },
      component: loadView('DashResume')
    },
    {
      path: '/EmailConfirmation',
      name: 'EmailConfiguration',
      meta: {
        authentication: true,
      },
      component: loadView('EmailConfiguration')
    },
    {
      path: '/IndividualList',
      name: 'IndividualList',
      meta: {
        authentication: true,
      },
      component: loadView('IndividualList')
    },
    {
      path: '/MobileComponents',
      name: 'MobileComponents',
      meta: {
        authentication: true,
      },
      component: loadView('MobileComponents')
    },
    {
      path: '/MobileDashboardOnboarding',
      name: 'MobileDashboardOnboarding',
      meta: {
        authentication: true,
      },
      component: loadView('MobileDashboardOnboarding')
    },
    {
      path: '/MobileAlertsSelection',
      name: 'MobileAlertsSelection',
      meta: {
        authentication: true,
      },
      component: loadView('MobileAlertsSelection')
    },
    {
      path: '/MobileCowList',
      name: 'MobileCowList',
      meta: {
        authentication: true,
      },
      component: loadView('MobileCowList')
    },
    {
      path: '/MobileCowRegistryData',
      name: 'MobileCowRegistryData',
      meta: {
        authentication: true,
      },
      component: loadView('MobileCowRegistryData')
    },
    {
      path: '/MobileCowStallConfiguration',
      name: 'MobileCowStallConfiguration',
      meta: {
        authentication: true,
      },
      component: loadView('MobileCowStallConfiguration')
    },
    {
      path: '/MobileNavBarTop',
      name: 'MobileNavBarTop',
      meta: {
        authentication: true,
      },
      component: loadView('MobileNavBarTop')
    },
    {
      path: '/MobileGroupCowFilterSelection',
      name: 'MobileGroupCowFilterSelection',
      meta: {
        authentication: true,
      },
      component: loadView('MobileGroupCowFilterSelection')
    },
    {
      path: '/MobileCowStall',
      name: 'MobileCowStall',
      meta: {
        authentication: true,
      },
      component: loadView('MobileCowStall')
    },
    {
      path: '/Login',
      name: 'Login',
      component: loadView('Login')
    },
    {
      path: '/PasswordReset',
      name: 'PasswordReset',
      meta: {
        authentication: true,
      },
      component: loadView('PasswordReset')
    },
    {
      path: '/UserProfile',
      name: 'UserProfile',
      meta: {
        authentication: true,
      },
      component: loadView('UserProfile')
    },
    {
      path: '/UserPlan',
      name: 'UserPlan',
      meta: {
        authentication: true,
      },
      component: loadView('UserPlan')
    },
    {
      path: '/UserType',
      name: 'UserType',
      meta: {
        authentication: true,
      },
      component: loadView('UserType')
    },
    {
      path: '/UserAdd',
      name: 'UserAdd',
      meta: {
        authentication: true,
      },
      component: loadView('UserAdd')
    },
    {
      path: '/DashGroup',
      name: 'DashGroup',
      meta: {
        authentication: true,
      },
      component: loadView('DashGroup')
    },
    {
      path: '/ActivateAlerts',
      name: 'ActivateAlerts',
      meta: {
        authentication: true,
      },
      component: loadView('ActivateAlerts')
    },
    {
      path: '/GroupForm',
      name: 'GroupForm',
      meta: {
        authentication: true,
      },
      component: loadView('GroupForm')
    },
    {
      path: '/Onboarding',
      name: 'Onboarding',
      meta: {
        authentication: true,
      },
      component: loadView('Onboarding')
    },
    {
      path: '/SpecificGroup',
      name: 'SpecificGroup',
      meta: {
        authentication: true,
      },
      component: loadView('SpecificGroup')
    },
    {
      path: '/RanchConfiguration',
      name: 'RanchConfiguration',
      meta: {
        authentication: true,
      },
      component: loadView('RanchConfiguration')
    },
    {
      path: '/Thanks',
      name: 'Thanks',
      meta: {
        authentication: true,
      },
      component: loadView('Thanks')
    },
    {
      path: '/AditionalModules',
      name: 'AditionalModules',
      meta: {
        authentication: true,
      },
      component: loadView('AditionalModules')
    },
    {
      path: '/History',
      name: 'History',
      meta: {
        authentication: true,
      },
      component: loadView('History')
    },
    {
      path: '/UserAdministration',
      name: 'UserAdministration',
      meta: {
        authentication: true,
      },
      component: loadView('UserAdministration')
    },
    {
      path: '/AddNewUser',
      name: 'AddNewUser',
      meta: {
        authentication: true,
      },
      component: loadView('AddNewUser')
    },
  ]
});

/*
router.beforeEach((to, from, next) => {
  const user = firebase.auth.currentUser;
  // cada ruta que tenga como meta authenticated
  const auth = to.matched.some(record => record.meta.authentication);
  // si no está autenticado entonces no avances de registeredUser
  if (auth && user === null) {
    next('/Login')
    // si está autenticado, ve a dashboard
  } else if (!auth && user !== null) {
    next('/Home')
  } else {
    next();
  }
});
*/

var onboardingStatus = 
console.log(onboardingStatus);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authentication)) {
    firebase.auth.onAuthStateChanged(function(user) {
      if (!user) {
        next('/Login');
      } else {
        var docRef = firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid);
        docRef.get().then(function(document) {
            if (document.exists) {
                if(document.data().onboarding == true){
                  if(to.fullPath === '/Onboarding'){
                    next('/Home')
                  }else{
                    next()
                  }
                }else{
                  next('/Onboarding')
                }
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
